import React, { useState, useEffect, Suspense } from "react";
import Select from "react-select";
import { Usuario } from "models/usuario";
import { UsuarioManager } from "managers";
import useMessage from "hooks/useMessage";
import ToolTip from "components/ToolTip/ToolTip";
import { DEFAULT_PAGINATION_VALUES } from "utils";
import { GridView, SvgComponent } from "components";
import IconButton from "components/IconButton/IconButton";
import Exportar from "components/Exportar/Exportar";
import useExceptionHandler from "hooks/useExceptionHandler";
import ListHeader from "components/PantallaList/Header/ListHeader";
import usePaginationValuesWhere from "../hooks/usePaginationValuesWhere";
import UsuarioEdit from "views/UsuarioEdit";
import SuspenseECF from "components/Suspense/SuspenseECF";

export default function UsuarioList({
  showLoading,
  hideLoading,
  hideTitle = false,
  isActive,
}) {
  const [where, setWhere] = useState({});
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION_VALUES);
  const [list, setList] = useState([]);
  const [showCanvas, setShowCanvas] = useState(false);
  const [showExportar, setShowExportar] = useState(false);
  const [idSec, setIdSec] = useState(undefined);
  const [esClonar, setEsClonar] = useState(false);
  const { setPaginationValuesWhere } = usePaginationValuesWhere();
  const { handleException } = useExceptionHandler();
  const { cerrarAlertas } = useMessage();
  const ESTATUS_LIST = [{ value: "", label: "Todos" }, ...Usuario.ESTATUS_LIST];

  useEffect(() => {
    if (isActive) {
      buscar();
    }
    return () => {
      cerrarAlertas();
      hideLoading();
    };
  }, [where, isActive]);

  const buscar = () => {
    const whereWithPaginationValues = { ...where, ...pagination };
    UsuarioManager.listado(whereWithPaginationValues)
      .then((res) => {
        setPaginationValuesWhere(res.Headers, pagination, setPagination);
        setList(res.Data);
      })
      .catch((error) => handleException(error))
      .finally(() => hideLoading());
  };

  const onPageIndexChanging = (pageNumber) => {
    setPagination((prevstate) => ({
      ...prevstate,
      IndiceDePagina: pageNumber - 1,
    }));
    setWhere({ ...where });
  };

  const handleClick = (params) => {
    if (params && params.Id) {
      setIdSec(params.Id);
      setEsClonar(params.Clonar === true);
    } else {
      setIdSec(undefined);
      setEsClonar(false);
    }
    setShowCanvas(true);
  };

  const updateList = () => {
    setWhere((prev) => ({ ...prev }));
  };

  return isActive ? (
    <>
      {showCanvas && (
        <Suspense fallback={<SuspenseECF />}>
          <UsuarioEdit
            showCanvas={showCanvas}
            setShowCanvas={setShowCanvas}
            IdSec={idSec}
            esClonar={esClonar}
            showLoading={showLoading}
            hideLoading={hideLoading}
            updateList={updateList}
          />
        </Suspense>
      )}

      <div style={{ paddingRight: isActive ? "15px" : "6px" }}>
        <ListHeader
          titulo={hideTitle ? "" : "Usuario"}
          crearNuevo={handleClick}
          exportar={() => setShowExportar(true)}
        />
      </div>

      <Exportar
        PROPIEDADES_EXPORTAR={Usuario.PROPIEDADES_EXPORTAR}
        showExportar={showExportar}
        setShowExportar={setShowExportar}
        showLoading={showLoading}
        hideLoading={hideLoading}
        where={where}
        exportarCallBack={UsuarioManager.exportarExcel}
      ></Exportar>

      <GridView
        pagination={pagination}
        setPagination={setPagination}
        allowPaging={pagination.EsPaginable}
        pageSize={pagination.CantidadPorPagina}
        pageIndex={pagination.IndiceDePagina}
        lastPageNumber={pagination.PaginasTotal}
        dataSource={list}
        onPageIndexChanging={onPageIndexChanging}
        where={where}
        setWhere={setWhere}
        height="70vh"
      >
        <GridView.Column
          bodyRenderer={(row) => (
            <div className="float-right">
              <IconButton onClick={() => handleClick({ Id: row.IdSec, Clonar: false })}>
                <ToolTip message="Ver">
                  <div>
                    <SvgComponent iconName="pencil" height="25px" width="25px" />
                  </div>
                </ToolTip>
              </IconButton>
              <IconButton onClick={() => handleClick({ Id: row.IdSec, Clonar: true })}>
                <ToolTip message="Clonar">
                  <div>
                    <SvgComponent iconName="copy" height="25px" width="25px" />
                  </div>
                </ToolTip>
              </IconButton>
            </div>
          )}
        />
        <GridView.Column
          headerText="Id"
          dataField="IdSec"
          sortExpression="IdSec"
          width="8%"
        />
        <GridView.Column
          headerText="Nombre de Usuario"
          dataField="NombreUsuario"
          sortExpression="NombreUsuario"
        />
        <GridView.Column
          headerText="Nombre Completo"
          dataField="Descripcion"
          sortExpression="Descripcion"
        />
        <GridView.Column
          headerText="Correo"
          dataField="Email"
          sortExpression="Email"
        />
        <GridView.Column
          headerText="Estatus"
          dataField="Estatus"
          sortExpression="Estatus"
          filterRenderer={() => (
            <Select
              className="react-select primary"
              options={ESTATUS_LIST}
              value={ESTATUS_LIST.filter(
                (option) =>
                  option.value ===
                  (where.Estatus ? where.Estatus : ESTATUS_LIST[0].value)
              )}
              name="Estatus"
              onChange={(e) => setWhere({ ...where, Estatus: e.value })}
            />
          )}
        />
      </GridView>
    </>
  ) : (
    <></>
  );
}
